//DBTables
import { DBModule, ModuleTypeFamily, ModuleTypeId } from "../../types/DBTables";
import { get, post } from "../../modules/server";
import Notify from "devextreme/ui/notify";
import { set, useForm } from "react-hook-form";

import { DTOBuilding } from "../../types/building";
import { getValueByString, nameof } from "../Global/Utils";
import ValidationSummaryMessages from "../Configuration/ValidationSummaryMessages";
import WizardStepEditor from "./WizardStepEditor";
import { useNavigate } from "react-router-dom";
import { useWizardHandler } from "../../modules/WizardHandler";
import { useGlobalData } from "../GlobalDataProvider";
import { Breadcrumb, BreadcrumbItem, Card } from "react-bootstrap";
import { IModuleByggnadsdata, IModuleVentilationFTXochFTConfig, IModuleVärmeElConfig } from "../../types/ModuleDatas";
import { useEffect, useState } from "react";
import { SystemText } from "../../types/help-text";
import { HtmlEditor } from "devextreme-react";
import { Colors } from "../../modules/Colors";

interface IProps {
  building: DTOBuilding;
  wizardStep: number;
  defaultData: any;
  cancelConfiguration: (m: DBModule | undefined) => void;
}
//KonfigurationDel1
const lastWizardStep = 4;

const WizardStepForm = ({ building, wizardStep, defaultData, cancelConfiguration }: IProps) => {
  const [pageDescriptions, setPageDescriptions] = useState<SystemText[]>([]);
  const [subscriptionParams, setSubscriptionParams] = useState({} as any);
  const [validationSummaryMessages, setValidationSummaryMessages] = useState<string[]>([] as string[]);
  const [checkValidation, setCheckValidation] = useState<boolean>(false);

  useEffect(() => {
    const fetchSystemTextGroup = async () => {
      const response = await get("GetSystemTextGroup/KonfigurationDel1");
      if (response.success) {
        setPageDescriptions(response.texts);
      }
    };

    const fetchSubscriptionParams = async () => {
      let subscriptionParams = {} as any;
      let currentBuildingJson = building.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata)?.data;
      let currentBuildingData = currentBuildingJson ? (JSON.parse(currentBuildingJson) as IModuleByggnadsdata) : undefined;
      let currentBuildingArea = currentBuildingData?.byggnadArea ? currentBuildingData.byggnadArea : 0;
      subscriptionParams["ThisBuildingArea"] = currentBuildingArea;
      const response = await get("GetCurrentSubscription");
      if (response.success) {
        subscriptionParams["NoOfBuildings"] = response.subscription.noOfBuildings;
        subscriptionParams["TotalSurfaceArea"] = response.subscription.totalSurfaceArea;
      }
      const response2 = await get("GetCurrentHousingStock");
      if (response2.success) {
        subscriptionParams["NoOfBuildingsCurrent"] = response2.housingStock.noOfBuildings;
        subscriptionParams["TotalSurfaceAreaCurrent"] = response2.housingStock.totalSurfaceArea;
      }

      setSubscriptionParams(subscriptionParams);
    };
    fetchSubscriptionParams();
    fetchSystemTextGroup();
  }, []);

  const navigate = useNavigate();
  const globalData = useGlobalData();
  const wizardHandler = useWizardHandler();

  const formHook = useForm({
    defaultValues: defaultData || {},
  });
  const watch = formHook.watch;

  const {
    handleSubmit,
    getValues,
    formState: { errors },
  } = formHook;

  const mByggnadsdata = building.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
  const byggArea = watch(mByggnadsdata?.id + ".data." + nameof<IModuleByggnadsdata>("byggnadArea"));
  const remainingArea = subscriptionParams.TotalSurfaceArea - (subscriptionParams.TotalSurfaceAreaCurrent - subscriptionParams.ThisBuildingArea) - (byggArea ? byggArea : 0);

  const getFormWizardStepTitle = (wizardStep: number) => {
    switch (wizardStep) {
      case 1:
        return "Information om byggnad";
      case 2:
        return "Ventilation";
      case 3:
        return "Värmesystem";
      case 4:
        return "Kylsystem";
      default:
        break;
    }
  };

  const getFormWizardStepDescription = () => {
    let text: SystemText | undefined;
    switch (wizardStep) {
      case 1:
        text = pageDescriptions.find((t) => t.id === "beskr_info.Byggnad");
        break;
      case 2:
        text = pageDescriptions.find((t) => t.id === "beskr_Ventilation");
        break;
      case 3:
        text = pageDescriptions.find((t) => t.id === "beskr_Värmesystem");
        break;
      case 4:
        text = pageDescriptions.find((t) => t.id === "beskr_Kylsystem");
        break;
    }
    return text?.body;
  };

  function appendFormDataToBuilding(data: any) {
    //, modules: DTOModule[]
    let buildingData = getValueByString(data, "building") as any;
    building.name = buildingData.namn;

    let modules = building.modules;
    modules.forEach((m) => {
      let wizardModuleFormData = getValueByString(data, "" + m.id) as any;
      let wizardModuleName = wizardModuleFormData?.name;
      let wizardModuleData = wizardModuleFormData?.data;
      let strData = "";

      if (wizardModuleData) {
        let moduleData;
        if (m.data) {
          moduleData = JSON.parse(m.data);
          moduleData = { ...moduleData, ...wizardModuleData };
        } else {
          moduleData = wizardModuleData;
        }
        strData = JSON.stringify(moduleData);
      } else {
        strData = "{}";
      }

      m.data = strData;
      if (m.moduleTypeId !== ModuleTypeId.Byggnadsdata && m.moduleTypeId !== ModuleTypeId.Lokaler) m.name = wizardModuleName ? wizardModuleName : "";
    });
  }

  const checkValidations = (validateAllSteps?: boolean) => {
    let duplicateNames;

    let arrMessages = [];
    try {
      const excludeModulesTypes = [ModuleTypeId.KylaSaknas, ModuleTypeId.VarmePrimarSaknas, ModuleTypeId.VarmeSekundarSaknas];
      const excludeModuleNamesTypes = [
        ModuleTypeId.KylaAnnatSystem,
        ModuleTypeId.KylaSaknas,
        ModuleTypeId.VarmePrimarAnnatSystem,
        ModuleTypeId.VarmePrimarSaknas,
        ModuleTypeId.VarmeSekundarSaknas,
      ];
      const includedModuleTypes = globalData.moduleTypes.filter((mt) => !excludeModulesTypes.includes(mt.id));
      const includedModules = building.modules.filter((m) => !excludeModulesTypes.includes(m.moduleTypeId));

      //duplicateNames = building.modules.filter((m) => !excludeModules.includes(m.moduleTypeId)).filter((m) => building.modules.find((m2) => m.name === m2.name && m.id !== m2.id));
      const duplicateNameModules = building.modules.filter((m) => !excludeModuleNamesTypes.includes(m.moduleTypeId));
      duplicateNames = duplicateNameModules.filter((m) => duplicateNameModules.find((m2) => m.name === m2.name && m.id !== m2.id));

      if (duplicateNames.length > 0) {
        let uniqueDuplicateNames = duplicateNames.reduce((arr, m) => (arr.find((n) => n === m.name) ? arr : arr.concat([m.name])), [] as string[]);
        let strDups = uniqueDuplicateNames.join(", ");

        arrMessages.push("Det finns moduler som har samma namn. Dessa namn finns fler än en gång: " + strDups);
      }

      if (wizardStep === 1 || validateAllSteps) {
        if (remainingArea < 0) {
          arrMessages.push("Det finns inte tillräckligt med yta kvar för att lägga till fler moduler");
        }
      }

      if (wizardStep === 2 || validateAllSteps) {
        const moduleTypesVentilation = globalData.moduleTypes.filter((mt) => mt.family === ModuleTypeFamily.Ventilation);
        const ventilationModules = includedModules.filter((m) => moduleTypesVentilation.find((mt) => mt.id === m.moduleTypeId));

        if (ventilationModules.length === 0) {
          arrMessages.push("Måste ha minst en ventilation");
        }
      }

      if (wizardStep === 3 || validateAllSteps) {
        const heatModuleTypesPrimary = includedModuleTypes.filter((mt) => mt.family === ModuleTypeFamily.VärmePrimar);
        const heatModuleTypesSecondary = includedModuleTypes.filter((mt) => mt.family === ModuleTypeFamily.VärmeSekundar || mt.family === ModuleTypeFamily.VärmeEl);

        const heatModulesPrimaryMissing = building.modules.filter((m) => m.moduleTypeId === ModuleTypeId.VarmePrimarSaknas);
        const heatModulesSecondaryMissing = building.modules.filter((m) => m.moduleTypeId === ModuleTypeId.VarmeSekundarSaknas);
        const heatModulesSecondaryWater = building.modules.filter((m) => m.moduleTypeId === ModuleTypeId.VarmeSekundarVatten);

        const ventilationFtxoFtModulesAll = building.modules.filter((m) => m.moduleTypeId === ModuleTypeId.VentilationFTX || m.moduleTypeId === ModuleTypeId.VentilationFT);
        const ventilationFtxoFtLuftburenModules = ventilationFtxoFtModulesAll.filter((m) => {
          let mData = m.data ? JSON.parse(m.data) : undefined;
          return mData ? mData[nameof<IModuleVentilationFTXochFTConfig>("ärHuvudsakligtVärmesystem")] === "Ja" : false;
        });

        const ventilationFxModules = building.modules.filter((m) => m.moduleTypeId === ModuleTypeId.VentilationFX);
        const heatModulesPrimary = building.modules.filter((m) => heatModuleTypesPrimary.find((mt) => mt.id === m.moduleTypeId)).concat(ventilationFxModules);
        const heatModulesSecondary = building.modules.filter((m) => heatModuleTypesSecondary.find((mt) => mt.id === m.moduleTypeId));

        //Must have chosen a primary system.
        //If there are any primary heat modules except missing, there must be at least one secondary heat module
        if (heatModulesPrimaryMissing.length === 0 && heatModulesPrimary.length === 0 && ventilationFtxoFtLuftburenModules.length === 0) {
          arrMessages.push("Gör ett val under primärvärmesystem");
        } else {
          if (heatModulesPrimary.length > 0 && heatModulesSecondaryMissing.length > 0) {
            arrMessages.push("Om det finns ett primärvärmesystem måste det finnas ett vattenburet sekundärvärmesystem");
          } else if (heatModulesPrimary.length > 0 && heatModulesSecondaryWater.length === 0) {
            arrMessages.push("Om det finns ett primärvärmesystem måste det finnas ett vattenburet sekundärvärmesystem");
          }
        }

        //Must have chosen a secondary system.
        //If there are any secondary heat modules, there must be at least one primary heat module
        //All secondary heat modules and direct electric systems must together be 100%
        if (heatModulesSecondaryMissing.length === 0 && heatModulesSecondary.length === 0) {
          arrMessages.push("Gör ett val under sekundärvärmesystem");
        } else {
          if (heatModulesSecondaryWater.length > 0 && heatModulesPrimaryMissing.length > 0) {
            arrMessages.push("Om det finns ett vattenburet sekundärvärmesystem måste det finnas ett primärvärmesystem");
          } else if (heatModulesSecondaryWater.length > 0 && heatModulesPrimary.length === 0) {
            arrMessages.push("Om det finns ett vattenburet sekundärvärmesystem måste det finnas ett primärvärmesystem");
          }

          let total = 0;
          let moduleOmrådeNames = [] as string[];
          let hasDuplicateOmrådeNames = false;
          heatModulesSecondary.forEach((m) => {
            let mData = m.data ? JSON.parse(m.data) : undefined;
            let mPart = mData[nameof<IModuleVärmeElConfig>("värmeSystemandel")] as number;
            let mOmråde = mData[nameof<IModuleVärmeElConfig>("betjäningsområde")] as string;
            if (mOmråde) {
              if (moduleOmrådeNames.includes(mOmråde)) {
                hasDuplicateOmrådeNames = true;
              } else {
                moduleOmrådeNames.push(mOmråde);
              }
            }
            total += mPart ? mPart : 0;
          });

          let områdeNameSameAsModuleNames = includedModules.reduce((acc: string[], m) => {
            if (moduleOmrådeNames.includes(m.name)) {
              return acc.concat([m.name]);
            }
            return acc;
          }, [] as string[]);

          if (heatModulesSecondary.length > 0 && total !== 100) {
            arrMessages.push("Alla sekundärvärmesystem och direktverkande elsystem måste tillsammans vara 100%");
          }
          if (hasDuplicateOmrådeNames) {
            arrMessages.push("Det finns moduler som har samma betjäningsområde. Betjäningsområden måste vara unika.");
          }
          if (områdeNameSameAsModuleNames.length > 0) {
            arrMessages.push(
              "Det finns betjäningsområde som har samma namn som modulnamn. Betjäningsområden kan inte vara samma som modulnamn. " + områdeNameSameAsModuleNames.join(", ")
            );
          }
        }
      }

      if (wizardStep === 4 || validateAllSteps) {
        const kylaModuleTypes = globalData.moduleTypes.filter((mt) => mt.family === ModuleTypeFamily.Kyla);
        const kylaModules = building.modules.filter((m) => kylaModuleTypes.find((mt) => mt.id === m.moduleTypeId));
        const kylaModulesKM = kylaModules.filter((m) => m.moduleTypeId === ModuleTypeId.KylaMaskin || m.moduleTypeId === ModuleTypeId.KylaAnnatSystem);
        const kylaModulesVatten = kylaModules.filter((m) => m.moduleTypeId === ModuleTypeId.KylaVattenburet);

        if (kylaModules.length === 0) {
          arrMessages.push("Gör ett val under kylsystem");
        }
        if (kylaModulesKM.length > 0 && kylaModulesVatten.length === 0) {
          arrMessages.push("Om det finns kylmaskiner måste det även finnas köldbärarssystem");
        }
      }

      return arrMessages;
    } catch (error) {
      Notify("Det gick inte att läsa av formuläret korrekt.", "error");
      return arrMessages;
    }
  };

  const onSubmit = async (data: any) => {
    appendFormDataToBuilding(data);
    let msgs: string[];

    if (wizardStep !== lastWizardStep) {
      msgs = checkValidations();
    } else {
      msgs = checkValidations(true);
    }

    if (msgs.length > 0) {
      setValidationSummaryMessages(msgs);
      setCheckValidation(true);
      return;
    } else {
      setValidationSummaryMessages([]);
      setCheckValidation(false);
    }

    if (wizardStep !== lastWizardStep) {
      navigate("../" + (wizardStep + 1));
    } else {
      try {
        const res = await post("SaveWizardBuilding", building);
        if (res?.succeeded) {
          PubSub.publish("RefreshBuildings");
          if (building.id > 0) navigate("../..");
          else navigate("/Buildings");
          Notify("Ändringarna har sparats", "success");
        } else {
          Notify(res.message, "error");
        }
      } catch (err) {
        Notify(err, "error");
        return;
      }
    }
  };

  const onSave = async () => {
    const data = getValues();
    let b = checkValidations(true);
    if (!b) {
      const step = validationSummaryMessages.findIndex((m) => m === "");
      return;
    }
    try {
      const res = await post("SaveWizardBuilding", building);
      if (res?.succeeded) {
        PubSub.publish("RefreshBuildings");
        if (building.id > 0) navigate("../..");
        else navigate("/Buildings");
        Notify("Ändringarna har sparats", "success");
      } else {
        Notify(res.message, "error");
      }
    } catch (err) {
      Notify(err, "error");
      return;
    }
  };

  const onBackwards = () => {
    const data = getValues();
    appendFormDataToBuilding(data);

    setValidationSummaryMessages([]);
    setCheckValidation(false);
    formHook.reset(data);

    navigate("../" + (wizardStep - 1));
  };

  const onAddModule = (mt: ModuleTypeId) => {
    let data = getValues();
    appendFormDataToBuilding(data);

    wizardHandler.addWizardModule(mt);
    data = wizardHandler.getWizardBuildingDefaultData();

    formHook.reset(data);

    //setWizardData(data);
  };

  const onRemoveModule = (mId: Number) => {
    let data = getValues();
    appendFormDataToBuilding(data);

    wizardHandler.removeModule(mId);
    data = wizardHandler.getWizardBuildingDefaultData();

    formHook.reset(data);
    //setWizardData(data);
  };

  const onAddOmråde = (mId: number, område: string) => {
    let data = getValues();
    data[mId].data.område = område; //mId + ".data.område
    appendFormDataToBuilding(data);

    data = wizardHandler.getWizardBuildingDefaultData();
    formHook.reset(data);
  };

  const onNavigateBreadCrumb = (wizardStep: number) => {
    let data = getValues();

    let b = checkValidations(data);
    if (!b) return;

    navigate("../" + wizardStep);
  };

  const onCancel = () => {
    cancelConfiguration(undefined);
  };

  const onHelp = () => {
    let text: string;
    switch (wizardStep) {
      case 1:
        text = "help_info.Byggnad";
        break;
      case 2:
        text = "help_Ventilation";
        break;
      case 3:
        text = "help_Värmesystem";
        break;
      case 4:
        text = "help_Kylsystem";
        break;
      default:
        text = "";
        break;
    }

    PubSub.publish("ShowHelp", text);
  };

  if (checkValidation) {
    const data = getValues();
    appendFormDataToBuilding(data);
    let msgs = checkValidations(false);
    let currntMsgs = validationSummaryMessages;
    let newMsgs = msgs.filter((m) => !currntMsgs.includes(m));
    let deletedMsgs = currntMsgs.filter((m) => !msgs.includes(m));

    if (msgs.length === 0) {
      setValidationSummaryMessages([]);
      setCheckValidation(false);
    } else if (newMsgs.length > 0 || deletedMsgs.length > 0) {
      setValidationSummaryMessages(msgs);
    }
  }

  return (
    <>
      <Breadcrumb className="">
        <BreadcrumbItem active={wizardStep === 1 ? true : false}>{getFormWizardStepTitle(1)}</BreadcrumbItem>
        <BreadcrumbItem active={wizardStep === 2 ? true : false}>{getFormWizardStepTitle(2)}</BreadcrumbItem>
        <BreadcrumbItem active={wizardStep === 3 ? true : false}>{getFormWizardStepTitle(3)}</BreadcrumbItem>
        <BreadcrumbItem active={wizardStep === 4 ? true : false}>{getFormWizardStepTitle(4)}</BreadcrumbItem>
      </Breadcrumb>
      <Card>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Card.Header>
            {getFormWizardStepTitle(wizardStep)}
            <div className="headerGroup">
              <div className="h5 m-0">{"Steg " + wizardStep + "/" + lastWizardStep}</div>
            </div>
          </Card.Header>
          <Card.Body style={{ minHeight: "500px" }}>
            <Card.Title>Beskrivning</Card.Title>
            <Card.Text>
              <HtmlEditor style={{}} valueType="html" value={getFormWizardStepDescription()} readOnly></HtmlEditor>
            </Card.Text>
            <div className="row"></div>
            <WizardStepEditor
              building={building}
              formHook={formHook}
              wizardStep={wizardStep}
              remainingArea={remainingArea}
              onAddModule={onAddModule}
              onRemoveModule={onRemoveModule}
              onAddOmråde={onAddOmråde}
            />
            <div className="flex-grow-1 mt-2">
              <ValidationSummaryMessages errors={errors} />
              <div style={{ color: Colors.RedMedium }}>{validationSummaryMessages.map((e, i) => (e === "" ? <></> : <div key={i}>{e}</div>))}</div>
            </div>
          </Card.Body>
          <Card.Footer>
            <div className="module">
              <button type="button" className="btn btn-info" onClick={onHelp}>
                Hjälp
              </button>
            </div>
            <div className="footerGroup">
              <button type="button" className="btn btn-md btn-danger me-3" onClick={onCancel}>
                Avbryt
              </button>
              {/* <button type="button" className="btn btn-primary me-3" onClick={onSave}>
                  Spara
                </button> */}
              <button type="button" className={"btn btn-secondary " + (wizardStep === 1 ? "disabled" : "")} onClick={onBackwards}>
                Förra steget
              </button>
              <button type="submit" className={"btn btn-success"}>
                {wizardStep === lastWizardStep ? "Spara" : "Nästa"}
              </button>
            </div>
          </Card.Footer>
        </form>
      </Card>
      {/* <div className="row d-flex align-items-center">
          <div className="col fs-2 fw-bold">{getFormWizardStepTitle(wizardStep)}</div>
          <div className="col pb-2 fw-bold d-flex justify-content-end">{"Steg " + wizardStep + "/" + lastWizardStep}</div>
        </div>
        <h3 className="mb-0">Beskrivning</h3>
        <div className="mb-4 p-1">
          <HtmlEditor valueType="html" value={getFormWizardStepDescription()} readOnly></HtmlEditor>
        </div> */}
      {/* <form onSubmit={handleSubmit(onSubmit)}>
          <div style={{ minHeight: "400px", overflow: "auto", paddingRight: 12, paddingLeft: 4 }}>
            <WizardStepEditor building={building} formHook={formHook} wizardStep={wizardStep} onAddModule={onAddModule} onRemoveModule={onRemoveModule} />
          </div>
          <div className="d-grid gap-2 d-md-flex justify-content-md-end">
            <div className="flex-grow-1">
              <ValidationSummaryMessages errors={errors} />
            </div>
            <div className="mt-4" style={{ paddingRight: 12, paddingLeft: 4 }}>
              <button type="button" className="btn btn-info ms-2 me-5" onClick={onHelp}>
                Hjälp
              </button>
              <button type="button" className="btn btn-secondary me-2" onClick={onCancel}>
                Avbryt
              </button>
              <button type="button" className="btn btn-primary me-5" onClick={onSave}>
                Spara
              </button>
              <button type="button" className={"btn btn-secondary me-2 " + (wizardStep === 1 ? "disabled" : "")} onClick={onBackwards}>
                Förra steget
              </button>
              <button type="submit" className={"btn btn-primary " + (wizardStep === lastWizardStep ? "disabled" : "")}>
                Nästa
              </button>
            </div>
          </div>
        </form> */}
    </>
  );
};

export default WizardStepForm;
